var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var AddressLine;
(function (AddressLine) {
    AddressLine["STREET"] = "street";
    AddressLine["LOCALITY"] = "locality";
    AddressLine["COUNTRY"] = "country";
})(AddressLine || (AddressLine = {}));
var emptyAddress = {
    streetNumber: '',
    streetName: '',
    street: '',
    country: '',
    city: '',
    zipcode: '',
    administrativeLevel2Short: '',
    state: '',
    stateShort: '',
};
var addressBuilderByCountryCode = {
    FR: function (a) {
        var _a;
        var _b;
        return (_a = {},
            _a[AddressLine.STREET] = ((_b = a.street) === null || _b === void 0 ? void 0 : _b.length) ? a.street : "".concat(a.streetNumber || '', " ").concat(a.streetName || '').trim(),
            _a[AddressLine.LOCALITY] = "".concat(a.zipcode || '', " ").concat(a.city || '').trim(),
            _a[AddressLine.COUNTRY] = a.country || '',
            _a);
    },
    IT: function (a) {
        var _a;
        var _b;
        var streetSep = !a.streetName || !a.streetNumber ? '' : ', ';
        var city = a.city || a.administrativeLevel3 || '';
        return _a = {},
            _a[AddressLine.STREET] = ((_b = a.street) === null || _b === void 0 ? void 0 : _b.length)
                ? a.street
                : "".concat(a.streetName || '').concat(streetSep).concat(a.streetNumber || '').trim(),
            _a[AddressLine.LOCALITY] = "".concat(a.zipcode || '', " ").concat(city, " ").concat(a.administrativeLevel2Short || '').trim(),
            _a[AddressLine.COUNTRY] = a.country || '',
            _a;
    },
    US: function (a) {
        var _a;
        var _b;
        return (_a = {},
            _a[AddressLine.STREET] = ((_b = a.street) === null || _b === void 0 ? void 0 : _b.length) ? a.street : "".concat(a.streetNumber || '', " ").concat(a.streetName || '').trim(),
            _a[AddressLine.LOCALITY] = "".concat(a.zipcode || '', " ").concat(a.city || '').trim(),
            _a[AddressLine.COUNTRY] = a.country || '',
            _a);
    },
};
export function addressToString(_a) {
    var countryCode = _a.countryCode, address = _a.address, _b = _a.separator, separator = _b === void 0 ? ', ' : _b, _c = _a.lines, lines = _c === void 0 ? [AddressLine.STREET, AddressLine.LOCALITY, AddressLine.COUNTRY] : _c;
    if (!addressBuilderByCountryCode[countryCode]) {
        throw new Error('Address structure not defined for the countryCode ' + countryCode);
    }
    var sanitizedAddress = __assign(__assign({}, emptyAddress), address);
    var addressLines = addressBuilderByCountryCode[countryCode](sanitizedAddress);
    return Object.entries(addressLines)
        .filter(function (_a) {
        var componentName = _a[0], addressLine = _a[1];
        return !!addressLine && lines.includes(componentName);
    })
        .map(function (_a) {
        var addressLine = _a[1];
        return addressLine;
    })
        .join(separator);
}
var fieldsToExtract = {
    administrativeLevel2Short: { name: 'administrative_area_level_2', countries: ['IT'], preferShort: true },
    administrativeLevel3: { name: 'administrative_area_level_3', countries: ['IT'] },
    country: { name: 'country', preferShort: true },
    streetNumber: { name: 'street_number' },
    streetName: { name: 'route' },
    zipcode: { name: 'postal_code' },
    city: { name: 'locality' },
    state: { name: 'administrative_area_level_1' },
    stateShort: { name: 'administrative_area_level_1', preferShort: true },
};
export function buildAddressFromGoogleInput(_a) {
    var googleAddress = _a.googleAddress, countryCode = _a.countryCode;
    var addressFieldsByType = reduceByType(googleAddress);
    var address = Object.entries(fieldsToExtract).reduce(function (accAddress, _a) {
        var fieldName = _a[0], field = _a[1];
        if (addressFieldsByType[field.name] &&
            addressFieldsByType[field.name].length > 0 &&
            isAllowedField({ field: field, countryCode: countryCode })) {
            accAddress[fieldName] = extractGoogleName(addressFieldsByType[field.name][0], field.preferShort);
        }
        return accAddress;
    }, {});
    var street = addressToString({ countryCode: countryCode, address: address, lines: [AddressLine.STREET] });
    if (street !== '') {
        address.street = street;
    }
    return address;
}
function isAllowedField(_a) {
    var countryCode = _a.countryCode, field = _a.field;
    return field && (field.countries === undefined || field.countries.includes(countryCode));
}
function reduceByType(addressFields) {
    return addressFields
        .filter(function (field) { return field.types; })
        .flatMap(function (field) { return field.types.map(function (type) { return ({ type: type, field: field }); }); })
        .reduce(function (types, _a) {
        var type = _a.type, field = _a.field;
        if (!types[type]) {
            types[type] = [];
        }
        types[type].push(field);
        return types;
    }, {});
}
function extractGoogleName(googleAddressField, preferShort) {
    if (preferShort === void 0) { preferShort = false; }
    if (!preferShort && googleAddressField.long_name) {
        return googleAddressField.long_name;
    }
    return googleAddressField.short_name || '';
}
